var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { useState, useEffect } from 'react';
import { noop } from "../../utils";
import { Box } from '../Box';
import { Input } from '../Input';
import { Tag } from '../Tag';
var keys = {
    enter: 13,
    backspace: 8
};
var tagLss = {
    my: 'xs',
    py: 0,
    px: 'md',
    mr: 'xxs',
    ml: 'xs',
    textScale: 'control',
    borderRadius: 'md',
    bg: 'gray300',
    color: 'primary',
    ':hover': {
        bg: 'secondary200'
    }
};
var invalidLss = {
    color: 'danger400',
    bg: 'white',
    borderColor: 'danger400',
    ':hover': {
        bg: 'gray100'
    }
};
export var MultiValue = function (_a) {
    var onChange = _a.onChange, splitCharacter = _a.splitCharacter, initialValues = _a.initialValues, invalidValues = _a.invalidValues, props = __rest(_a, ["onChange", "splitCharacter", "initialValues", "invalidValues"]);
    var _b = __read(useState(''), 2), inputValue = _b[0], setInputValue = _b[1];
    var _c = __read(useState(initialValues || ['']), 2), values = _c[0], setValues = _c[1];
    var removeValue = function (index) {
        var newValues = __spread(values);
        if (index > -1) {
            newValues.splice(index, 1);
        }
        setValues(newValues);
    };
    var onKeyDown = function (ev) {
        var target = ev.target;
        switch (ev.keyCode) {
            case keys.enter:
                if (target.value === '')
                    return;
                setValues(__spread(values, [target.value.toString()]));
                setInputValue('');
                break;
            case keys.backspace:
                if (target.value === '')
                    removeValue(values.length - 1);
                break;
        }
    };
    var onInputChange = function (value) {
        if (splitCharacter && value.indexOf(splitCharacter) !== -1) {
            var lastCharIndex = value.length - 1;
            var shouldRemoveLastChar = value[lastCharIndex] === splitCharacter;
            // removes the split character in the last index
            var sanitizedValue = shouldRemoveLastChar
                ? value.slice(0, lastCharIndex)
                : value;
            setValues(__spread(values, sanitizedValue.split(splitCharacter).filter(Boolean)));
            setInputValue('');
        }
        else {
            setInputValue(value);
        }
    };
    useEffect(function () {
        onChange && onChange(values);
    }, [values]);
    return (React.createElement(React.Fragment, null,
        values.map(function (value, index) { return (React.createElement(Tag, { key: "value-" + index, tabIndex: -1, isVisible: true, isRound: true, palette: "secondary", 
            // no-op when clicking on tag content
            onClick: noop, onRemove: function () { return removeValue(index); }, lss: (invalidValues === null || invalidValues === void 0 ? void 0 : invalidValues.includes(value)) ? __assign(__assign({}, tagLss), invalidLss) : tagLss }, value)); }),
        React.createElement(Box, { lss: { flex: 1 } },
            React.createElement(Input, __assign({}, props, { onKeyDown: onKeyDown, onChange: function (ev) { return onInputChange(ev.target.value); }, value: inputValue })))));
};
//# sourceMappingURL=MultiValue.js.map